import { render, staticRenderFns } from "./BalanceReasonInfoBadge.vue?vue&type=template&id=158f276a&scoped=true"
import script from "./BalanceReasonInfoBadge.vue?vue&type=script&lang=js"
export * from "./BalanceReasonInfoBadge.vue?vue&type=script&lang=js"
import style0 from "./BalanceReasonInfoBadge.vue?vue&type=style&index=0&id=158f276a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158f276a",
  null
  
)

export default component.exports